"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MicrofrontendRouter = exports.MicrofrontendRouterBase = void 0;
class MicrofrontendRouterBase {
    constructor(dynamicLoadManager, basename) {
        this.getMicrofrontendIdFromUrl = () => {
            return window.location.pathname.replace(this.basename, '').split('/')[1];
        };
        this.loadFirstMicrofrontend = (data, onLoad) => __awaiter(this, void 0, void 0, function* () {
            const id = this.getMicrofrontendIdFromUrl();
            yield this.dynamicLoadManager.loadVertical(id, data);
            if (onLoad) {
                onLoad();
            }
        });
        this.createMicrofrontendRoute = (microfrontendId, data, onLoad) => __awaiter(this, void 0, void 0, function* () {
            window.addEventListener(microfrontendId, (event) => __awaiter(this, void 0, void 0, function* () {
                const { detail: { url, state }, } = event;
                window.history.pushState(state, '', url);
                yield this.dynamicLoadManager.loadVertical(microfrontendId, data);
                onLoad && onLoad();
            }));
            window.addEventListener('popstate', (_) => __awaiter(this, void 0, void 0, function* () {
                const id = this.getMicrofrontendIdFromUrl();
                if (microfrontendId === id) {
                    yield this.dynamicLoadManager.loadVertical(id, data);
                    onLoad && onLoad();
                }
            }));
        });
        this.dynamicLoadManager = dynamicLoadManager;
        this.basename = basename;
    }
}
exports.MicrofrontendRouterBase = MicrofrontendRouterBase;
MicrofrontendRouterBase.goToMicrofront = (microfrontId, path, state) => {
    const url = `${microfrontId}${path ? `/${path}` : ''}`;
    const event = new CustomEvent(microfrontId, { detail: { url, state } });
    window.dispatchEvent(event);
};
class MicrofrontendRouter extends MicrofrontendRouterBase {
}
exports.MicrofrontendRouter = MicrofrontendRouter;
//# sourceMappingURL=microfrontendRouter.js.map